import { gql } from 'graphql-request'

export const QueryVideo = gql`
  fragment QueryVideo on WistiaVideoModelRecord {
    id
    videoId
    videoSource
    thumbnail {
      mimeType
      url
      title
      width
      height
      responsiveImage {
        ...responsiveImageFragment
      }
    }
    playText
  }
`
